import React from 'react';

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

export interface IconCalendarClockProps extends SvgIconProps {}

const IconCalendarClock: React.FC<IconCalendarClockProps> = ({ ...rest }) => (
  <SvgIcon viewBox="0 0 20 21" {...rest}>
    <path d="M2 8H16V10.5H18V4C18 2.9 17.1 2 16 2H15V0H13V2H5V0H3V2H2C0.89 2 0.00999999 2.9 0.00999999 4L0 18C0 19.1 0.89 20 2 20H11L10 18H2V8ZM2 4H16V6H2V4Z" />
    <path d="M14.3636 12H13V15.6948L16.2727 17.6667L17 16.5399L14.3636 14.9437V12Z" />
    <path
      fill-rule="evenodd" // eslint-disable-line
      clip-rule="evenodd" // eslint-disable-line
      d="M14 21C17.3137 21 20 18.3137 20 15C20 11.6863 17.3137 9 14 9C10.6863 9 8 11.6863 8 15C8 18.3137 10.6863 21 14 21ZM14.0001 19.2857C16.367 19.2857 18.2858 17.3669 18.2858 15C18.2858 12.6331 16.367 10.7143 14.0001 10.7143C11.6331 10.7143 9.71436 12.6331 9.71436 15C9.71436 17.3669 11.6331 19.2857 14.0001 19.2857Z"
    />
  </SvgIcon>
);

export default IconCalendarClock;
